import React from 'react'
import { graphql } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { EcoSystem } from './mapper'

type FirmEcoSystemProps = {
  ecoSystems: EcoSystem[] | null
}

const FirmEcoSystem: React.FC<FirmEcoSystemProps> = ({ ecoSystems }) => {
  if (!ecoSystems || ecoSystems.length === 0) {
    return null
  }
  return (
    <div className="p-4">
      <h2 className="mb-2 text-xl font-semibold text-left text-night">
        Notre écosystème
      </h2>
      <ul className="flex flex-col items-center justify-center">
        {ecoSystems?.map((eco) => (
          <li
            className="flex flex-col items-center justify-center my-1"
            key={eco?.name}
          >
            <div className="w-20 h-auto">
              {eco?.logo &&
                typeof eco.logo === 'object' &&
                'images' in eco.logo && (
                  <GatsbyImage image={eco.logo} alt={eco?.name ?? 'Outil'} />
                )}
              {eco?.logo && typeof eco.logo === 'string' && (
                <img src={eco.logo} alt={eco?.name ?? 'Outil'} />
              )}
              {!eco?.logo && eco?.logoUrl && (
                <img src={eco.logoUrl} alt={eco?.name ?? 'Outil'} />
              )}
              {!eco?.logo && !eco?.logoUrl && (
                <img
                  src="../../../Logo_V_Lamacompta.jpg"
                  alt="Logo par défaut de l'outil"
                />
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default FirmEcoSystem

export const query = graphql`
  fragment FirmEcoSystem on STRAPI_ACCOUNTING_FIRM {
    ecosystems {
      name
      id
      logo {
        localFile {
          childImageSharp {
            gatsbyImageData
          }
          extension
          url
        }
      }
    }
  }
`
